import React from "react";
import PlusIcon from "../Icons/PlusIcon";
import ColorPlate from "./ColorPlate";
import { fixedColors } from "./data";

interface Props {
  selectedColor: string;
  updateCode: (val: string) => void;
  colorPlateAlign?: "start" | "center" | "end";
}

const Index: React.FC<Props> = ({
  selectedColor,
  updateCode,
  colorPlateAlign,
}) => {
  return (
    <div className="flex flex-wrap gap-2 ">
      {fixedColors.map((color, index) => (
        <div
          key={index}
          className={`${
            color == selectedColor
              ? ` border-[0.5px] rounded-sm flex justify-center items-center size-[20px]`
              : ""
          }  `}
          style={{ borderColor: selectedColor }}
        >
          <div
            className="size-[16px] rounded-sm cursor-pointer"
            style={{ backgroundColor: color }}
            onClick={() => updateCode(color)}
          />
        </div>
      ))}

      <ColorPlate
        trigger={
          <button className="w-[16px] h-[16px] rounded-full cursor-pointer flex items-center justify-center relative rounded-md rounded data-[state=open]:bg-gray-200 ">
            <PlusIcon />
          </button>
        }
        color={selectedColor}
        updateColor={updateCode}
        colorPlateAlign={colorPlateAlign}
      />
    </div>
  );
};

export default Index;
